import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';

/** Static element mapping. No model-supplied CSS/HTML, no scraping. */
const targets = {
  'whatsapp.number.label': {title:'Etichetta interna',description:'Qui riconosci il numero usato dal team. Evidenziarlo non modifica la configurazione.'},
  'whatsapp.assign-operator': {title:'Assegna al collega',description:'Qui puoi scegliere chi gestisce questa conversazione. Evidenziarlo non salva una modifica.'},
  'whatsapp.internal-note': {title:'Note interne',description:'Le note aiutano il collega a continuare il lavoro e non vengono inviate su WhatsApp al cliente.'},
} as const;
export function highlightLabel() { return highlightTarget('whatsapp.number.label'); }
export function highlightTarget(id:keyof typeof targets) {
  if (document.body.classList.contains('driver-active')) return false;
  const nodes = document.querySelectorAll(`[data-consultant="${id}"]`);
  const element = Array.from(nodes).find(node => node.getClientRects().length > 0);
  if (!element) return false;
  const rect = element.getBoundingClientRect();
  const x = rect.left + rect.width / 2, y = rect.top + rect.height / 2;
  if (x >= 0 && y >= 0 && x < window.innerWidth && y < window.innerHeight) {
    const top = document.elementFromPoint(x, y);
    if (top && !element.contains(top)) return false;
  }
  driver({ allowClose: true, overlayOpacity: 0.25, stageRadius: 10, stagePadding: 6 }).highlight({
    element, popover: targets[id],
  });
  return true;
}
